<ng-template #templateRef
             let-columns>
  <colgroup>
    @if (tableSettings.selectionMode) {
      <col>
    }
    @if (tableSettings.reordering?.separateColumn) {
      <col>
    }
    @for (col of columns; track col) {
      <col>
    }
    @if (hasActionsColumn()) {
      <col>
    }
  </colgroup>
</ng-template>